import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters('user', [
      'getDealer',
    ]),
  },

  methods: {
    ...mapActions('account/warehouse', [
      'warehouseLoad',
    ]),

    ...mapActions('user', [
      'userInfoWarehouseSet',
    ]),

    ...mapMutations('user', [
      'userInfoWarehouseUpdate'
    ]),

    $_wholesale_update() {
      this.togglePreload();
      const value = () => {
        if (this.getDealer.has_warehouse == 0) {
          return 1;
        }
        return 0;
      }
      this.userInfoWarehouseSet(value()).then(res => {
        if (value() === 0) {
          this.userInfoWarehouseUpdate(value());
          this.warehouseLoad().then(res => {
            this.togglePreload();
            this.updatePopup(null, null);
          })
        } else {
          this.warehouseLoad().then(res => {
            this.userInfoWarehouseUpdate(value());
            this.togglePreload();
            this.updatePopup(null, null);
          })
        }
      })
    }
  }
}